import { render, staticRenderFns } from "./labelRule.vue?vue&type=template&id=03ac8ea3&scoped=true"
import script from "./labelRule.vue?vue&type=script&lang=js"
export * from "./labelRule.vue?vue&type=script&lang=js"
import style0 from "./labelRule.vue?vue&type=style&index=0&id=03ac8ea3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ac8ea3",
  null
  
)

export default component.exports